import { callApi } from "Apis";
import { SETTINGURL } from "helpers/constant";

export async function settingListApi(data) {
  try {
    const response = await callApi({ url: SETTINGURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function settingAdd(data) {
  try {
    const response = await callApi({ url: SETTINGURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getSettingById(id) {
  try {
    const response = await callApi({ url: SETTINGURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateSetting(data) {
  try {
    const response = await callApi({ url: SETTINGURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteSettingById(id) {
  try {
    const response = await callApi({ url: SETTINGURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
